<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M1.4,782.5c0,0-0.9,1.8-0.9,4.49c0,1.79,0.9,1.79,1.8,3.59c0.54,1.07,0.9,2.65,1.8,2.7c1.85,0.09,0.9-3.59,0.9-3.59
	s2.69,2.7,2.69,8.09c0,1.95-1.59,3.35-3.32,4.24c0.34-0.49,0.58-1.01,0.63-1.55c0.23-2.33-5.39-5.39-5.39-5.39s-3.59,3.47-3.59,5.39
	c0,0.77,0.43,1.47,1.06,2.04c-1.9-0.71-3.75-2.1-3.75-4.73c0-3.6,2.08-3.68,2.7-6.29c0.34-1.46,0-1.8,0.9-3.59
	C-2.23,786.17,1.4,782.5,1.4,782.5L1.4,782.5z"/>
</svg>

</template>